var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmexColored = function SvgAmexColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#amex_colored_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4v16h16V4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v16h16v-2.528h-2.208l-.816-.955-.848.955H9.856v-5.083h-2.07l2.587-5.856h2.518l.608 1.328V6.533h3.125l.523 1.392.512-1.392H20V4H4Zm14.192 3.36-.821 2.165-.219.587-.224-.587-.827-2.165h-1.808v4.267h1.088V8.848l-.005-.56.213.56 1.04 2.779h1.035l1.045-2.779.203-.555v3.334H20V7.36h-1.808Zm-7.232 0-1.888 4.267h1.237l.331-.822h2.07l.33.822h1.253L12.416 7.36H10.96Zm.501 1.445.214-.533.213.533.443 1.078h-1.312l.442-1.078Zm6.816 3.59-1.285 1.381-1.28-1.381h-4.981v4.25h3.562v-.922H11.82v-.742h2.426v-.917H11.82v-.747h2.474v-.922l1.99 2.133-1.99 2.117h1.376l1.296-1.386 1.291 1.386h1.413l-1.994-2.133 1.994-2.117h-1.392Zm.518 2.112L20 15.733v-2.437l-1.205 1.21Z",
    fill: "#006FCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "amex_colored_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgAmexColored;